var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_17",
    "data-name": "Subtraction 17",
    d: "M11.5,23A11.5,11.5,0,0,1,3.369,3.368,11.5,11.5,0,1,1,19.631,19.632,11.423,11.423,0,0,1,11.5,23Zm-1.239-7.741v1.818h2.066V15.259Zm1.02-9.509H11.26a1.646,1.646,0,0,0-1.223.5,1.9,1.9,0,0,0-.449,1.448c.1,1.8.246,3.293.449,4.691.2,1.361.277,1.683,1.125,1.683.292,0,.659-.038,1.168-.091h.016q.06-.494.12-.979l.007-.056c.088-.707.17-1.375.246-2.058.026-.24.055-.485.083-.72v-.013c.094-.793.19-1.613.219-2.423a1.971,1.971,0,0,0-.5-1.481A1.682,1.682,0,0,0,11.282,5.75Z",
    transform: "translate(0.5 0.5)",
    fill: "#0094d9",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.0669f1c070508b9aa059aa365121d0ff.svg";
export { ForwardRef as ReactComponent };